import React from 'react';
import i18n from 'i18n';
import { Trans } from 'react-i18next';

import { Button } from 'react-bootstrap';
import styles from './errorPage.module.scss';
import _ from 'lodash';

// Vite-compatible replacement for webpack's runtime `require()`: glob
// the images at build time so dynamic `errorCode` resolves to a URL.
// `import.meta.glob` paths are relative to THIS file, not the `assets`
// import alias — so reach up to `src/assets/`.
const errorImages = import.meta.glob<string>('../../assets/*.png', {
  eager: true,
  import: 'default',
  query: '?url'
});

const getErrorImage = (errorCode: string | number, retina: boolean) => {
  const suffix = retina ? '@2x.png' : '.png';
  return errorImages[`../../assets/${errorCode}${suffix}`];
};

export const ErrorPage: React.FC<any> = (props) => {
  const getRedirectPath = () => {
    const currentPath = props.currentPath.replace(
      `/error${props.errorCode.toString()}`,
      ''
    );
    const target = currentPath.slice(0, currentPath.lastIndexOf('/'));
    return _.isEmpty(target) ? '/' : target;
  };

  const onBackClicked = () => {
    props.onBackClicked(getRedirectPath());
  };

  return (
    <div className={styles.errorPage}>
      <img
        src={getErrorImage(props.errorCode, false)}
        srcSet={`${getErrorImage(props.errorCode, true)} 2x`}
        alt='logo'
      />
      <div className={styles.label}>
        <Trans
          i18nKey={`errorPage.labels.${props.errorCode}`}
          components={{ 1: <br />, 3: <span /> }}
        />
      </div>
      <div className={styles.buttons}>
        <Button variant='primary' size='sm' onClick={onBackClicked}>
          {i18n.t('errorPage.labels.back')}
        </Button>
      </div>
    </div>
  );
};
